import React from 'react';
import Grid2 from '@mui/material/Grid2';
import { FormControl, FormControlLabel, Checkbox, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MultiSelectPicklist from './MultiSelectPicklist';

export interface CountyAreasValues {
  countyMiamiDade: boolean;
  countyBroward: boolean;
  countyPalmBeach: boolean;
  areasOfWorkMiamiDade: string;
  areasOfWorkBroward: string;
  areasOfWorkPalmBeach: string;
}

interface Props {
  values: CountyAreasValues;
  fieldErrors: Record<string, string | undefined>;
  handleCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleMultiSelectChange: (e: { target: { name: string; value: string[] } }) => void;
}

const COUNTIES = [
  { checkbox: 'countyMiamiDade', areas: 'areasOfWorkMiamiDade', canWorkKey: 'form.canWorkMiamiDade', canWork: 'I can work in Miami Dade', areasLabel: 'Areas of Work - Miami Dade' },
  { checkbox: 'countyBroward', areas: 'areasOfWorkBroward', canWorkKey: 'form.canWorkBroward', canWork: 'I can work in Broward', areasLabel: 'Areas of Work - Broward' },
  { checkbox: 'countyPalmBeach', areas: 'areasOfWorkPalmBeach', canWorkKey: 'form.canWorkPalmBeach', canWork: 'I can work in Palm Beach', areasLabel: 'Areas of Work - Palm Beach' },
] as const;

/** County checkboxes with their areas-of-work pickers, shared by the caregiver form and the availability update page. */
const CountyAreasFields: React.FC<Props> = ({ values, fieldErrors, handleCheckboxChange, handleMultiSelectChange }) => {
  const { t } = useTranslation();

  return (
    <>
      {COUNTIES.map((county) => (
        <Grid2 key={county.checkbox} container size={12} spacing={2} alignItems="center">
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <FormControl component="fieldset">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values[county.checkbox]}
                    onChange={handleCheckboxChange}
                    name={county.checkbox}
                  />
                }
                label={t(county.canWorkKey, county.canWork)}
              />
            </FormControl>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 8 }}>
            {values[county.checkbox] && (
              <MultiSelectPicklist
                fieldName={county.areas}
                value={values[county.areas]}
                onChange={handleMultiSelectChange}
                label={t(`form.${county.areas}`, county.areasLabel)}
                objectName="caregiver"
                maxSelections={5}
                required
                error={!!fieldErrors[county.areas]}
                helperText={fieldErrors[county.areas]}
              />
            )}
          </Grid2>
        </Grid2>
      ))}

      {/* County Selection Error Message */}
      {fieldErrors.countySelection && (
        <Grid2 size={12}>
          <Typography color="error" variant="body2" sx={{ mt: 1 }}>
            {fieldErrors.countySelection}
          </Typography>
        </Grid2>
      )}
    </>
  );
};

export default CountyAreasFields;
